import { UserStorage } from '@grafana/runtime/internal';

const userStorage = new UserStorage('saved-queries');

const FILTER_DEFAULTS_KEY = 'filter-defaults';

export const getStoredFilterDefaults = async <T>(): Promise<Partial<T>> => {
  const value = await userStorage.getItem(FILTER_DEFAULTS_KEY);
  return value ? JSON.parse(value) : {};
};

export const storeFilterDefaults = async <T>(filters: T): Promise<void> => {
  await userStorage.setItem(FILTER_DEFAULTS_KEY, JSON.stringify(filters));
};
